import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import { Box, Button, Paper, TextField, Checkbox } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import { useCookies } from "react-cookie";
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AppHeader from "../../component/AppHeader";
import api from "../../../API";
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

const SampleListPage = (props:any) => {

  const samples = props.samples;
  
  return (
    <Paper sx={{margin: "-56px", borderTop: "4px solid #3e36a5", width:"720px", height:"550px", marginRight:"100px", overflow: "hidden"}}>
      <Box sx={{padding:"20px 8px 8px 8px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>샘플 제출 현황</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        <TableContainer component={Paper} sx={{maxHeight:"440px"}}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center"><Box sx={{width:"60px", color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                <TableCell align="center"><Box sx={{width:"80px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>처리상태</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>파일</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>업로드시간</Box></TableCell>
                {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>녹음파일</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>자막파일</Box></TableCell>
                <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>사진파일</Box></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {samples.map((sample:any, idx:number) => (
                <React.Fragment key={idx+1}>
                  <TableRow
                    key={idx+1}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row" align="center" sx={{width:"80px", fontWeight:700}}>
                      <Box sx={{width:"80px"}}>{sample.idx}</Box>
                    </TableCell>
                    <TableCell align="center" sx={{fontWeight:600}}><Button sx={{fontWeight:700, color:"#fff", backgroundColor: (sample.state === "샘플반려" ? "red" : "#3fb92e")}}>{sample.state}</Button></TableCell>
                    <TableCell align="left"><Box>{sample.file_audio}</Box><Box>{sample.file_srt}</Box><Box>{sample.file_photo}</Box></TableCell>
                    <TableCell align="left">{sample.ins_date}</TableCell>
                    {/* <TableCell align="left">{sample.file_srt}</TableCell>
                    <TableCell align="left">{sample.file_photo}</TableCell> */}
                    
                  </TableRow>
                  {(sample.reject_rsn && sample.reject_rsn != 'None' ) ? 
                    <TableRow
                      key={idx+1+"_reject"}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="right" sx={{fontWeight:600}}>
                        <Box><SubdirectoryArrowRightIcon /></Box>
                      </TableCell>
                      <TableCell align="center" sx={{fontWeight:600}}>
                        <Box sx={{width: "80px", height:"20px", color:"#fff", fontWeight:600, backgroundColor:"#caa75b", marginRight:"24px", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>
                          반려사유
                        </Box>
                      </TableCell>
                      <TableCell colSpan={2} align="left" sx={{fontWeight:600}}>
                        <Box>{sample.reject_rsn}</Box>
                      </TableCell>
                    </TableRow>
                  : ""}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default SampleListPage;
